import { TestConfig } from "@/API";
import { GetPublicChatUrl } from "@/APIURL";
import { CopyText } from "@/Components/CopyText";
import { GenerateRandomString } from "@/Helpers/RandomString";
import { Button, Text, Group, Modal, Switch, Stack, TextInput, ActionIcon, Tooltip } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconReload } from "@tabler/icons-react";
import { PropsWithChildren, useEffect } from "react";

export function TestConfigEditButton(props: { workspaceId: string, chatBotDataId: string, config?: TestConfig, onChange?: (config: TestConfig) => void } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);
    const form = useForm<TestConfig>({
        initialValues: props.config,
        validate: {
        }
    });
    useEffect(() => {
        if (opened) {
            if (props.config) form.setValues(props.config)
            else form.reset()
        }
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="測試設定" size="xl">
            <form onSubmit={form.onSubmit((values) => {
                props.onChange?.(values)
                // close()
            })}>
                <Switch
                    label="允許公開測試"
                    {...form.getInputProps('allowPublicAccess', { type: "checkbox" })}
                />
                {form.getValues().allowPublicAccess &&
                    <Stack mt="sm" gap={5}>
                        <TextInput
                            label="公開測試金鑰"
                            placeholder="optional"
                            rightSection={
                                <Tooltip color="gray" label="隨機產生金鑰">
                                    <ActionIcon variant="light" onClick={() => {
                                        form.setFieldValue("publicAccessKey", GenerateRandomString(20))
                                    }}>
                                        <IconReload style={{ width: '70%', height: '70%' }} stroke={1.5} />
                                    </ActionIcon>
                                </Tooltip>}
                            {...form.getInputProps('publicAccessKey')}
                        />
                        <Text size="sm" c="gray">公開測試連結</Text>
                        <CopyText text={window.origin + GetPublicChatUrl(props.workspaceId, props.chatBotDataId, encodeURIComponent(form.getValues().publicAccessKey ?? ""))} />
                    </Stack>}
                <Group justify="flex-end" mt="md">
                    <Button type="submit">保存</Button>
                </Group>
            </form>
        </Modal >
    </>
}